import { ProductAccommodationsLine } from 'Components/lines/product-accommodations-line/ProductAccommodationsLine';
export default ProductAccommodationsLine;
